//  @flow
import type { Dispatch } from "redux"

import { itemToPaySelector } from "./paymentSelector"
import { SERVICES } from "mmb/consts/additionalServices"
// eslint-disable-next-line import/no-cycle
import { setCategory } from "../../../services/additionalServices"
// eslint-disable-next-line import/no-cycle
import { openModal } from "../../../services"
import { MODALS } from "mmb/consts/booking"
import type AdditionalService from "common/records/AdditionalService"
import type { SubmitForPaymentActionPayload, ReducerState, Action } from "../records/PropTypes"
import {
  ADDITIONAL_SERVICE_ORDER_SUCCESS,
  SET_MOBILE_SUMMARY_VISIBILITY,
  SUBMIT_FOR_PAYMENT,
} from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingPayment/records/consts"

export const submitForPayment = (payload: SubmitForPaymentActionPayload) => (
  dispatch: Dispatch<any>,
) => {
  if (payload.price <= 0) {
    return dispatch(payload.orderAction(payload))
  }
  return dispatch({
    type: SUBMIT_FOR_PAYMENT,
    price: payload.price,
    margin: payload.margin || 0,
    currency: payload.currency,
    category: payload.category,
    orderAction: payload.orderAction,
    payload: payload.payload,
    modal: MODALS.PAYMENT,
    _track: payload,
  })
}

export const hideMobileSummary: () => Action = () => ({
  type: SET_MOBILE_SUMMARY_VISIBILITY,
  payload: {
    state: false,
  },
})

export const showMobileSummary: () => Action = () => ({
  type: SET_MOBILE_SUMMARY_VISIBILITY,
  payload: {
    state: true,
  },
})

const CATEGORY_TO_MODALS = {
  [SERVICES.INSURANCE]: MODALS.INSURANCE,
  [SERVICES.BAGGAGE]: MODALS.BAGS,
  [SERVICES.SEATING]: MODALS.SEATING,
  [SERVICES.CHANGE_FLIGHTS]: MODALS.CHANGE_FLIGHTS,
  [SERVICES.SCHEDULE_CHANGE]: MODALS.SCHEDULE_CHANGE,
  [SERVICES.ASSISTED_REFUND]: MODALS.REFUND,
  [SERVICES.MEALS]: MODALS.MEALS,
}

// $FlowFixMe
export const returnToOrderingStage = () => (
  dispatch: Dispatch<*>,
  getState: () => ReducerState,
) => {
  const state = getState()
  const { category } = itemToPaySelector(state)

  // when opening generic SERVICES modal, which insurance is a part of, we need to set category first
  if (category === SERVICES.INSURANCE) {
    dispatch(setCategory(category))
  }

  dispatch(openModal(CATEGORY_TO_MODALS[category]))
}

// $FlowFixMe
export const additionalServiceOrderSuccess = (additionalService: AdditionalService) => ({
  type: ADDITIONAL_SERVICE_ORDER_SUCCESS,
  payload: {
    additionalService,
  },
})
